import API from './fetch_api.js';
import axios from '../axios/axios.js';
export default {
    /***************省****************/
    provices() {
        return axios.post(API.provices)
    },
    /***************市****************/
    cities(proviceId) {
        return axios.post(API.cities + proviceId)
    },
    /***************区****************/
    counties(cityId) {
        return axios.post(API.counties + cityId)
    },
    detail(districtId) {
        return axios.post(API.detail + districtId)
    },


    /**********获取一级、二级、三级类目**********/
    getListLevelBackendCategory(parentId) {
        return axios.post(API.getListLevelBackendCategory + parentId, )
    },
    /**************添加类目************/
    saveBackendCategoryDtoByBelongStore(ids) {
        return axios.post(API.saveBackendCategoryDtoByBelongStore, {
            status: 3,
            ids
        })
    },

    /***********类目回显***********/
    getBackendCategoryByMerchantId() {
        return axios.post(API.getBackendCategoryByMerchantId, {})
    },
    /*删除类目*/
    cancelBackendCategory(ids) {
        return axios.post(API.cancelStoreCategory, ids)
    },

    /**********************************************登录*******************************************/
    login(username, password, type) {
        return axios.post(API.login, {
            username,
            password,
            type
        })
    },
    /*****************************************基本信息*********************************************/
    insertMerchantQualification(formdata) { /*基本信息添加*/
        return axios.post(API.insertMerchantQualification, formdata)
    },
    updateMerchantQualificationById(formdata) { /*基本信息修改*/
        return axios.post(API.updateMerchantQualificationById, formdata)
    },
    getMerchantInfoByLoginName(formdata) { /*基本信息回显*/
        return axios.post(API.getMerchantInfoByLoginName, formdata)
    },
    /*****************************************经营信息*********************************************/
    insertMerchantAccount(formdata) { /*经营信息添加*/
        return axios.post(API.insertMerchantAccount, formdata)
    },
    updateMerchantManageInfoById(formdata) { /*经营信息修改*/
        return axios.post(API.updateMerchantManageInfoById, formdata)
    },
    getMercahntManageInfoByLoginName() { /*经营信息回显*/
        return axios.post(API.getMercahntManageInfoByLoginName, {})
    },
    /***************************************经营范围*****************************************/
    insertStoreInfo(formdata) { /*经营范围添加*/
        return axios.post(API.insertStoreInfo, formdata)
    },
    getMerchantTypeByLoginName() { /*经营范围回显*/
        return axios.post(API.getMerchantTypeByLoginName)
    },
    /*********************************************缴费****************************************************/
    insertPayImage(formdata) { /*上传缴费凭证*/
        return axios.post(API.insertPayImage, formdata)
    },
    getCostInfoByIds(formdata) { /*缴费回显*/
        return axios.post(API.getCostInfoByIds, formdata)
    },
    /***********************************************************************************/
    selectMerchantauditLogDetail(id) { /*审核不通过回显*/
        return axios.post(API.selectMerchantauditLogDetail + id)
    },
    selectMerchantauditLog(formdata) { /*审核记录*/
        return axios.post(API.selectMerchantauditLog, formdata)
    },
    getMerchantInfoStateByLoginName() { /*查询*/
        return axios.post(API.getMerchantInfoStateByLoginName, {})
    },

    saveStoreCategory(categoryIds, status) { //添加类目
        return axios.post(API.saveStoreCategory, {
            categoryIds,
            status
        })
    },
    getStoreCategory() { //类目回显
        return axios.post(API.getStoreCategory)
    }
}


// WEBPACK FOOTER //
// ./src/api/fetch.js